import React, { useMemo, useState } from "react";
import {
  Box,
  Button,
  Flex,
  Image,
  Text,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter,
  FormControl,
  FormLabel,
  InputGroup,
  InputRightElement,
} from "@chakra-ui/react";
import DatePicker from "react-datepicker";
import { registerLocale } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import vi from "date-fns/locale/vi";
import calendarIcon from "../../assets/images/onleave/calendar.svg";
import iconExcel from "../../assets/images/employee/iconExcel.svg";
import IconFile from "../../assets/images/booking/upfile.svg";
import TableJobTitle from "./tableJobTitle";
import { useAttendance } from "../../hooks/useAttendance";
import { exportExcelLocal, exportFile } from "../../utils/tools";
import toast from "react-hot-toast";
import { attendanceCall } from "../../api/attendance";
import PopupImport from "../../components/popup/PopupImport";
import FormLockAttendance from "./popupForm/formLockAttendance";
import FormStandardWorking from "./popupForm/formStandardWorking";

registerLocale("vi", vi);

const columnMappingReverseAttendanceSupportBusiness = {
  Tháng: "month",
  Năm: "year",
  "Mã nhân viên": "employeeCode",
  "Tên nhân viên": "employeeName",
  "Chức vụ": "jobPositionName",
  Phòng: "supportDepartmentName",
  "Mã trưởng phòng": "supportDepartmentManagerCode",
  "Chi nhánh": "branchName",
  "Mã giám đốc chi nhánh": "branchManagerCode",
  "Tổng công tiêu chuẩn": "totalStandardWorking",
  "Tổng công thực tế": "workingDays",
};

const columnMappingReverseAttendanceBusiness = {
  Tháng: "month",
  Năm: "year",
  "Mã nhân viên": "employeeCode",
  "Tên nhân viên": "employeeName",
  "Chức vụ": "jobPositionName",
  Khối: "saleBlockName",
  "Mã giám đốc khối": "saleBlockManagerCode",
  Vùng: "saleAreaName",
  "Mã giám đốc vùng": "saleAreaManagerCode",
  "Chi nhánh": "branchName",
  "Mã giám đốc chi nhánh": "branchManagerCode",
  "Tổng công tiêu chuẩn": "totalStandardWorking",
  "Tổng công thực tế": "workingDays",
  "Loại nhân viên": "businessCategoryName",
  "Có là elite không": "isElite",
};

export default function JobTitle() {
  const [params, setParams] = useState({
    search: "",
    saleAreaId: null,
    saleBlockId: null,
    department: null,
    supportDepartmentsId: null,
    branchesId: null,
    businessCategoryIds: [],
    status: null,
    date: null,
  });

  const [popupImportSupportBusiness, setPopupImportSupportBusiness] =
    useState(false);
  const [popupImportBusiness, setPopupImportBusiness] = useState(false);

  const [isRebuildOpen, setIsRebuildOpen] = useState(false);
  const [rebuildDate, setRebuildDate] = useState(new Date());
  const [isRebuilding, setIsRebuilding] = useState(false);

  const [isEliteOpen, setIsEliteOpen] = useState(false);
  const [eliteDate, setEliteDate] = useState(new Date());
  const [isUpdatingElite, setIsUpdatingElite] = useState(false);

  const [isLockOpen, setIsLockOpen] = useState(false);
  const [isStandardWorkingOpen, setIsStandardWorkingOpen] = useState(false);

  const handleUpdateElite = async () => {
    setIsUpdatingElite(true);
    const toastId = toast.loading("Đang cập nhật Elite...");
    const month = eliteDate.getMonth() + 1;
    const year = eliteDate.getFullYear();
    try {
      await attendanceCall.updateEliteByMonth(month, year);
      toast.success(`Cập nhật Elite tháng ${month}/${year} thành công`);
      refetch();
      setIsEliteOpen(false);
    } catch (error) {
      console.error(error);
    } finally {
      toast.dismiss(toastId);
      setIsUpdatingElite(false);
    }
  };

  const handleRebuild = async () => {
    setIsRebuilding(true);
    const toastId = toast.loading("Đang cập nhật dữ liệu thống kê...");
    const month = rebuildDate.getMonth() + 1;
    const year = rebuildDate.getFullYear();
    try {
      await attendanceCall.rebuildMonthlyEmployeeStatistics(month, year);
      toast.success(
        `Cập nhật dữ liệu thống kê tháng ${month}/${year} thành công`,
      );
      refetch();
      setIsRebuildOpen(false);
    } catch (error) {
      console.error(error);
    } finally {
      toast.dismiss(toastId);
      setIsRebuilding(false);
    }
  };

  const {
    attendanceData,
    refetch,
    isLoading,
    isRefetching,
    totalPages,
    setCurrentPage,
    currentPage,
    entries,
    startEntry,
    endEntry,
  } = useAttendance(
    params.saleBlockId,
    params.saleAreaId,
    params.department,
    params.supportDepartmentsId,
    params.branchesId,
    params.businessCategoryIds,
    params.search,
    params.date,
    params.status,
  );

  const handleExport = async () => {
    const checkInColumnMapping = {
      date: "Thời gian",
      codeEmployee: "Mã nhân viên",
      fullName: "Tên nhân viên",
      saleBlock: "Khối",
      saleArea: "Vùng",
      jobPosition: "Chức vụ",
      commissionRate: "Tỉ lệ phí dịch vụ",
      workingDays: "Ngày công",
      businessCategory: "Phân loại",
    };

    if (attendanceData?.length) {
      const data = await attendanceCall.export(entries, params);
      if (data) {
        exportFile(
          data,
          checkInColumnMapping,
          "danh_sach_xac_nhan_cong_va_chuc_danh.xlsx",
        );
        toast.success("Download file thành công");
      } else {
        toast.error("Không có dữ liệu");
      }
    } else toast.error("Không có dữ liệu");
  };

  const handleExportSupportBusiness = () => {
    const columnMapping = {
      month: "Tháng",
      year: "Năm",
      employeeCode: "Mã nhân viên",
      employeeName: "Tên nhân viên",
      jobPositionName: "Chức vụ",
      supportDepartmentName: "Phòng",
      supportDepartmentManagerCode: "Mã trưởng phòng",
      branchName: "Chi nhánh",
      branchManagerCode: "Mã giám đốc chi nhánh",
      totalStandardWorking: "Tổng công tiêu chuẩn",
      workingDays: "Tổng công thực tế",
    };

    const data = [
      {
        month: 3,
        year: 2026,
        employeeCode: "MSH005246",
        employeeName: "Chu Minh Nguyệt",
        jobPositionName: "Nhân viên",
        branchName: "Hội sở Hà Nội",
        totalStandardWorking: "24",
        workingDays: "0",
      },
      {
        month: 3,
        year: 2026,
        employeeCode: "MSH005245",
        employeeName: "Trần Văn Khánh",
        jobPositionName: "Nhân viên",
        supportDepartmentName: "Phòng Hành chính nhân sự",
        totalStandardWorking: "24",
        workingDays: "1",
      },
      {
        month: 3,
        year: 2026,
        employeeCode: "MSH005244",
        employeeName: "Trần Thanh Huyền",
        jobPositionName: "Nhân viên",
        supportDepartmentName: "Phòng Hành chính nhân sự",
        totalStandardWorking: "24",
        workingDays: "1",
      },
      {
        month: 3,
        year: 2026,
        employeeCode: "MSH005235",
        employeeName: "Lương Thu Huyền",
        jobPositionName: "Nhân viên",
        supportDepartmentName: "Phòng Hành chính nhân sự",
        totalStandardWorking: "24",
        workingDays: "1",
      },
    ];

    exportExcelLocal({
      data,
      mapping: columnMapping,
      filename: "mau_import_cong_va_chuc_danh_NV_ho_tro_kinh_doanh.xlsx",
      toastMessages: { success: "Download file thành công" },
    });
  };

  const handleExportBusiness = () => {
    const columnMapping = {
      month: "Tháng",
      year: "Năm",
      employeeCode: "Mã nhân viên",
      employeeName: "Tên nhân viên",
      jobPositionName: "Chức vụ",
      saleBlockName: "Khối",
      saleBlockManagerCode: "Mã giám đốc khối",
      saleAreaName: "Vùng",
      saleAreaManagerCode: "Mã giám đốc vùng",
      branchName: "Chi nhánh",
      branchManagerCode: "Mã giám đốc chi nhánh",
      totalStandardWorking: "Tổng công tiêu chuẩn",
      workingDays: "Tổng công thực tế",
      businessCategoryName: "Loại nhân viên",
      isElite: "Có là elite không",
    };

    const data = [
      {
        month: 3,
        year: 2026,
        employeeCode: "CTV005267",
        employeeName: "Vũ Hoàng Sơn",
        jobPositionName: "Nhân viên",
        saleBlockName: "Nguyễn Mậu Bảo",
        saleBlockManagerCode: "CTV000697",
        saleAreaName: "Nguyễn Ngọc Hải",
        saleAreaManagerCode: "CTV000432",
        branchName: "Hội sở Hà Nội",
        totalStandardWorking: "24",
        workingDays: "0",
        businessCategoryName: "Cộng tác viên",
        isElite: "Không",
      },
      {
        month: 3,
        year: 2026,
        employeeCode: "CTV005266",
        employeeName: "Nguyễn Thị Tuyết",
        jobPositionName: "Nhân viên",
        saleBlockName: "Lê Thị Phương",
        saleBlockManagerCode: "CTV001435",
        saleAreaName: "Hà Minh Thức",
        saleAreaManagerCode: "CTV000373",
        branchName: "Thanh Hóa",
        totalStandardWorking: "24",
        workingDays: "0",
        businessCategoryName: "Elite Nhận Lương (Fulltime)",
        isElite: "Có",
      },
      {
        month: 3,
        year: 2026,
        employeeCode: "CTV005265",
        employeeName: "Nguyễn Quốc Việt",
        jobPositionName: "Nhân viên",
        saleBlockName: "Lê Thị Phương",
        saleBlockManagerCode: "CTV001435",
        saleAreaName: "Hà Minh Thức",
        saleAreaManagerCode: "CTV000373",
        branchName: "Thanh Hóa",
        totalStandardWorking: "24",
        workingDays: "0",
        businessCategoryName: "Elite Không Lương (Fulltime)",
        isElite: "Có",
      },
      {
        month: 3,
        year: 2026,
        employeeCode: "CTV005264",
        employeeName: "Trương Doãn Hùng",
        jobPositionName: "Nhân viên",
        saleBlockName: "Hà Minh Thức",
        saleBlockManagerCode: "CTV000373",
        saleAreaName: "Hà Minh Thức",
        saleAreaManagerCode: "CTV000373",
        branchName: "Hội sở Hà Nội",
        totalStandardWorking: "24",
        workingDays: "1",
        businessCategoryName: "CVKD (Parttime)",
        isElite: "Không",
      },
    ];

    exportExcelLocal({
      data,
      mapping: columnMapping,
      filename: "mau_import_cong_va_chuc_danh_NV_kinh_doanh.xlsx",
      toastMessages: { success: "Download file thành công" },
    });
  };

  return (
    <Box
      w={{ base: "100%" }}
      backgroundColor="var(--color-backgroundmain)"
      p={{ base: "24px 16px 16px" }}
    >
      <Flex alignItems={"center"} justifyContent={"space-between"}>
        <Flex alignItems={"center"} gap={{ base: "74px" }}>
          <Text fontSize={{ base: "20px" }} fontWeight={600}>
            Xác nhận công và chức danh
          </Text>
        </Flex>

        <Flex gap={4} flexWrap={"wrap"} justifyContent={"flex-end"}>
          <Button
            display={"flex"}
            alignItems={"center"}
            p={"10px 16px 10px 12px"}
            gap={"8px"}
            backgroundImage="var(--color-button)"
            _hover={{ filter: "brightness(90%)" }}
            onClick={() => setPopupImportSupportBusiness(true)}
          >
            <Image src={IconFile} />
            <Text
              fontSize={{ base: "15px" }}
              fontWeight={600}
              color="var(--color-main)"
            >
              Import NV hỗ trợ kinh doanh
            </Text>
          </Button>

          <Button
            display={"flex"}
            alignItems={"center"}
            p={"10px 16px 10px 12px"}
            gap={"8px"}
            backgroundImage="var(--color-button)"
            _hover={{ filter: "brightness(90%)" }}
            onClick={() => setPopupImportBusiness(true)}
          >
            <Image src={IconFile} />
            <Text
              fontSize={{ base: "15px" }}
              fontWeight={600}
              color="var(--color-main)"
            >
              Import NV kinh doanh
            </Text>
          </Button>

          <Button
            display={"flex"}
            alignItems={"center"}
            p={"10px 16px 10px 12px"}
            gap={"8px"}
            backgroundImage="var(--color-button)"
            _hover={{ filter: "brightness(90%)" }}
            onClick={() => setIsRebuildOpen(true)}
          >
            <Text
              fontSize={{ base: "15px" }}
              fontWeight={600}
              color="var(--color-main)"
            >
              Cập nhật dữ liệu thống kê
            </Text>
          </Button>

          <Button
            display={"flex"}
            alignItems={"center"}
            p={"10px 16px 10px 12px"}
            gap={"8px"}
            backgroundImage="var(--color-button)"
            _hover={{ filter: "brightness(90%)" }}
            onClick={() => setIsEliteOpen(true)}
          >
            <Text
              fontSize={{ base: "15px" }}
              fontWeight={600}
              color="var(--color-main)"
            >
              Cập nhật Elite
            </Text>
          </Button>

          <Button
            display={"flex"}
            alignItems={"center"}
            p={"10px 16px 10px 12px"}
            gap={"8px"}
            backgroundImage="var(--color-button)"
            _hover={{ filter: "brightness(90%)" }}
            onClick={() => setIsStandardWorkingOpen(true)}
          >
            <Text
              fontSize={{ base: "15px" }}
              fontWeight={600}
              color="var(--color-main)"
            >
              Sửa ngày công chuẩn
            </Text>
          </Button>

          <Button
            display={"flex"}
            alignItems={"center"}
            p={"10px 16px 10px 12px"}
            gap={"8px"}
            backgroundImage="var(--color-button)"
            _hover={{ filter: "brightness(90%)" }}
            onClick={() => setIsLockOpen(true)}
          >
            <Text
              fontSize={{ base: "15px" }}
              fontWeight={600}
              color="var(--color-main)"
            >
              Chốt bảng công
            </Text>
          </Button>

          <Button
            display={"flex"}
            alignItems={"center"}
            p={"10px 16px 10px 12px"}
            gap={"8px"}
            backgroundImage="var(--linear-gradient-excel)"
            _hover={{ filter: "brightness(90%)" }}
            onClick={handleExport}
          >
            <Image src={iconExcel} />
            <Text
              fontSize={{ base: "15px" }}
              fontWeight={600}
              color="var(--color-main)"
            >
              Xuất excel
            </Text>
          </Button>
        </Flex>
      </Flex>

      <Box mt={{ base: "23px" }}>
        <TableJobTitle
          paramData={setParams}
          attendanceData={attendanceData}
          refetch={refetch}
          isLoading={isLoading}
          isRefetching={isRefetching}
          totalPages={totalPages}
          setCurrentPage={setCurrentPage}
          currentPage={currentPage}
          entries={entries}
          startEntry={startEntry}
          endEntry={endEntry}
        />
      </Box>

      {popupImportSupportBusiness && (
        <PopupImport
          isOpen={popupImportSupportBusiness}
          onClose={() => setPopupImportSupportBusiness(false)}
          refetchCheckInData={refetch}
          columnMappingReverse={columnMappingReverseAttendanceSupportBusiness}
          handleExport={handleExportSupportBusiness}
          titleAdd="Thêm công và chức danh nhân viên hỗ trợ kinh doanh"
          inputAdd="Nhập danh sách công và chức danh hàng tháng của nhân viên hỗ trợ kinh doanh"
          type={"importAttendanceSupportBusiness"}
        />
      )}

      {popupImportBusiness && (
        <PopupImport
          isOpen={popupImportBusiness}
          onClose={() => setPopupImportBusiness(false)}
          refetchCheckInData={refetch}
          columnMappingReverse={columnMappingReverseAttendanceBusiness}
          handleExport={handleExportBusiness}
          titleAdd="Thêm công và chức danh nhân viên kinh doanh"
          inputAdd="Nhập danh sách công và chức danh hàng tháng của nhân viên kinh doanh"
          type={"importAttendanceBusiness"}
        />
      )}

      {isLockOpen && (
        <FormLockAttendance
          isOpen={isLockOpen}
          onClose={() => setIsLockOpen(false)}
          onLocked={refetch}
        />
      )}

      {isStandardWorkingOpen && (
        <FormStandardWorking
          isOpen={isStandardWorkingOpen}
          onClose={() => setIsStandardWorkingOpen(false)}
          onUpdated={refetch}
        />
      )}

      <Modal isOpen={isRebuildOpen} onClose={() => setIsRebuildOpen(false)}>
        <ModalOverlay />
        <ModalContent
          backgroundColor="var(--color-main)"
          borderRadius={"16px"}
          padding={"8px"}
          maxW={"420px"}
        >
          <ModalHeader
            fontSize={"18px"}
            fontWeight={600}
            color={"var(--color-header-employee)"}
          >
            Cập nhật dữ liệu thống kê nhân viên
          </ModalHeader>
          <ModalBody>
            <FormControl>
              <FormLabel
                fontSize={"12px"}
                fontWeight={400}
                color={"var(--color-label-employee)"}
                mb={"6px"}
              >
                Tháng / Năm
              </FormLabel>
              <InputGroup>
                <DatePicker
                  selected={rebuildDate}
                  onChange={(date) => setRebuildDate(date)}
                  dateFormat="MM/yyyy"
                  locale="vi"
                  showMonthYearPicker
                  placeholderText="mm/yyyy"
                  className="datePickerStyle"
                  portalId="datepicker-portal"
                  popperProps={{ strategy: "fixed" }}
                  style={{ width: "100%" }}
                />
                <InputRightElement pointerEvents="none" h={"44px"}>
                  <Image src={calendarIcon} />
                </InputRightElement>
              </InputGroup>
            </FormControl>
          </ModalBody>
          <ModalFooter gap={"12px"}>
            <Button
              onClick={() => setIsRebuildOpen(false)}
              variant={"ghost"}
              borderRadius={"8px"}
              h={"44px"}
              fontSize={"15px"}
            >
              Hủy
            </Button>
            <Button
              onClick={handleRebuild}
              isLoading={isRebuilding}
              loadingText="Đang cập nhật dữ liệu..."
              borderRadius={"8px"}
              background={"var(--linear-gradient-employee)"}
              color={"var(--color-main)"}
              h={"44px"}
              fontSize={"15px"}
              _hover={{ filter: "brightness(90%)" }}
            >
              Cập nhật dữ liệu
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>

      <Modal isOpen={isEliteOpen} onClose={() => setIsEliteOpen(false)}>
        <ModalOverlay />
        <ModalContent
          backgroundColor="var(--color-main)"
          borderRadius={"16px"}
          padding={"8px"}
          maxW={"420px"}
        >
          <ModalHeader
            fontSize={"18px"}
            fontWeight={600}
            color={"var(--color-header-employee)"}
          >
            Cập nhật Elite theo tháng
          </ModalHeader>
          <ModalBody>
            <FormControl>
              <FormLabel
                fontSize={"12px"}
                fontWeight={400}
                color={"var(--color-label-employee)"}
                mb={"6px"}
              >
                Tháng / Năm
              </FormLabel>
              <InputGroup>
                <DatePicker
                  selected={eliteDate}
                  onChange={(date) => setEliteDate(date)}
                  dateFormat="MM/yyyy"
                  locale="vi"
                  showMonthYearPicker
                  placeholderText="mm/yyyy"
                  className="datePickerStyle"
                  portalId="datepicker-portal"
                  popperProps={{ strategy: "fixed" }}
                  style={{ width: "100%" }}
                />
                <InputRightElement pointerEvents="none" h={"44px"}>
                  <Image src={calendarIcon} />
                </InputRightElement>
              </InputGroup>
            </FormControl>
          </ModalBody>
          <ModalFooter gap={"12px"}>
            <Button
              onClick={() => setIsEliteOpen(false)}
              variant={"ghost"}
              borderRadius={"8px"}
              h={"44px"}
              fontSize={"15px"}
            >
              Hủy
            </Button>
            <Button
              onClick={handleUpdateElite}
              isLoading={isUpdatingElite}
              loadingText="Đang cập nhật Elite..."
              borderRadius={"8px"}
              background={"var(--linear-gradient-employee)"}
              color={"var(--color-main)"}
              h={"44px"}
              fontSize={"15px"}
              _hover={{ filter: "brightness(90%)" }}
            >
              Xác nhận
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </Box>
  );
}
